import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../auth/authStore';
import { configureApi } from '../api/client';
import { authApi } from '../api/endpoints';
import { ShieldCheck, ArrowRight, AlertCircle } from 'lucide-react';

export function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const setAuth = useAuthStore((s) => s.setAuth);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    console.log('[Login] intentando POST a', (import.meta.env.VITE_API_BASE_URL || '/api') + '/auth/login');
    try {
      const data = await authApi.login(username, password);
      console.log('[Login] OK, token recibido, expires:', data.expiresAt);
      setAuth(data.token, data.expiresAt, data.usuario);
      navigate(from, { replace: true });
    } catch (err) {
      console.error('[Login] fallo:', err?.response?.status, err?.response?.data || err?.message);
      setError(err?.response?.data?.error || 'No se pudo iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-30 pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, #06b6d4 0%, transparent 50%), radial-gradient(circle at 80% 70%, #3b82f6 0%, transparent 50%)' }} />

      <div className="relative w-full max-w-md bg-panel border border-border rounded-2xl shadow-2xl p-8">
        <div className="flex flex-col items-center mb-7">
          <img
            src="/VVSOLUTIONS_LOGO.png"
            alt="VVSOLUTIONS"
            className="w-40 h-auto mb-4 drop-shadow-lg"
          />
          <h1 className="text-2xl font-bold text-white tracking-wide">VVSRS</h1>
          <p className="text-xs text-muted tracking-widest mt-1">VISOR DE SERVICIOS Y SOPORTE</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-300 mb-1.5 tracking-wide">USUARIO</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
              className="w-full px-4 py-2.5 bg-panel-2 border border-border rounded-lg text-white placeholder-muted focus:outline-none focus:border-cyan-500 transition"
              placeholder="admin"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-slate-300 mb-1.5 tracking-wide">CONTRASEÑA</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              className="w-full px-4 py-2.5 bg-panel-2 border border-border rounded-lg text-white placeholder-muted focus:outline-none focus:border-cyan-500 transition"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div className="flex items-center gap-2 px-3 py-2 bg-rose-500/10 border border-rose-500/30 rounded-lg text-rose-400 text-sm">
              <AlertCircle size={16} />
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-semibold rounded-lg shadow-lg shadow-cyan-500/20 disabled:opacity-50 transition"
          >
            {loading ? 'Verificando...' : <>Iniciar Sesión <ArrowRight size={16} /></>}
          </button>
        </form>

        <div className="mt-6 pt-5 border-t border-border flex items-center gap-2 text-[11px] text-muted">
          <ShieldCheck size={14} className="text-emerald-400" />
          <span>Conexión segura · JWT + BCrypt</span>
        </div>
      </div>
    </div>
  );
}
